import { ComponentProps } from 'react';
import { Flex, Text } from '@qga/roo-ui/components';

import Skeleton from '@shared/v2/components/Skeleton/Skeleton';
import { BEST_RATE_TEXT } from '@shared/v2/constants/packages';
import useToggle from '@shared/v2/hooks/useToggle';

import Button from '@/components/Button/Button';
import RoomOptionDetails from '@/v2/components/pages/PackageView/components/RoomOptionDetails';
import useAlternativeOffer from '@/v2/components/pages/PackageView/hooks/useAlternativeOffer';
import Modal from '@/v2/components/ui/Modal';

const StyledButton = ({
  children,
  ...props
}: ComponentProps<typeof Button>) => {
  return (
    <Button variant="primary" width="100%" px={3} py="10px" {...props}>
      <Text display="block" lineHeight="1.5" fontWeight="bold" fontSize="sm">
        {children}
      </Text>
    </Button>
  );
};

const AlternativeOfferButton = () => {
  // Modal State
  const { value: isOpen, setOn: openModal, setOff: closeModal } = useToggle();

  // Alternative Offer Data
  const {
    alternativeOffer,
    handleSelectAltOffer,
    alternativeOfferPackageOption,
  } = useAlternativeOffer() || {};
  const { offer, roomType, leadInOffer } = alternativeOffer || {};
  const isAltOfferAvailable = !!(offer && roomType);

  // Click Handler
  const handleSelectPackage = () => {
    handleSelectAltOffer();
    closeModal();
  };

  if (!isAltOfferAvailable) {
    return null;
  }

  return (
    <>
      {/*@ts-ignore - TS doesn't get styled-system props*/}
      <Skeleton.Button width="100%">
        {/* @ts-expect-error outline is valid but not inferred correctly */}
        <StyledButton outline onClick={openModal}>
          Other Option
        </StyledButton>
      </Skeleton.Button>
      {/* MODAL */}
      {isOpen && (
        <Modal onClose={closeModal}>
          <Modal.Header>Other package option</Modal.Header>
          <Modal.Body p="5">
            <Flex gap="6" justifyContent="space-between" flexDirection="column">
              <RoomOptionDetails
                title="Other package option:"
                offer={{ ...offer, leadInOffer }}
                roomName={roomType.name}
                packageName={
                  alternativeOfferPackageOption?.title ?? BEST_RATE_TEXT
                }
              />
              <Flex flexDirection="column" gap="4">
                <StyledButton onClick={handleSelectPackage}>
                  Select Package
                </StyledButton>
                {/* @ts-expect-error outline is valid but not inferred correctly */}
                <StyledButton outline onClick={closeModal}>
                  Cancel
                </StyledButton>
              </Flex>
            </Flex>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default AlternativeOfferButton;
